import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../Contexts/AuthContext";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

const RequirePublicAccess = () => {
  const { isAdmin, isOperator, loading } = useAuth();
  if (loading) {
    return <LoadingOverlay fullscreen />;
  }

  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  if (isOperator) {
    return <Navigate to="/operador" replace />;
  }

  return <Outlet />;
}

export default RequirePublicAccess;
